import * as angular from 'angular';
import {IController} from "angular";

export class BringozDateAndTimePickerComponent implements IController {
  date: any;
  isRaised: any;
  ticks: any;
  minDate: any;
  maxDate: any;
  onChange: Function;

  constructor(private $mdPanel, private moment) {
  }

  $onInit() {
    if (!this.ticks) {
      this.ticks = 300000;
    }
  }

  onOpen($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_END,
        null  // CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.date-and-time-picker')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          date: this.date,
          ticks: this.ticks,
          minDate: this.minDate,
          maxDate: this.maxDate
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: DateAndTimePanelComponent,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/commons/components/bringoz-date-and-time-picker/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel, reason) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(config) {
    this.onChange({date: config.date});
  }
}

export class DateAndTimePanelComponent implements IController {
  dataRef: any;
  config: any;

  constructor(private mdPanelRef, private moment) {
    this.dataRef = mdPanelRef.constructor.locals.data;
    this.config = {
      dateRef: this.moment(this.dataRef.date).toDate(),
      date: this.moment(this.dataRef.date).valueOf(),
      ticks: this.dataRef.ticks,
      minDate: this.dataRef.minDate ? this.moment(this.dataRef.minDate).toDate() : undefined,
      maxDate: this.dataRef.maxDate ? this.moment(this.dataRef.maxDate).toDate() : undefined,
      min: this.moment(this.dataRef.date).startOf('day').valueOf(),
      max: this.moment(this.dataRef.date).endOf('day').valueOf(),
    };
  }


  onChangeDate(date) {
    this.config.dateRef = date;
    this.config.date = this.moment(date).valueOf();
    this.config.min = this.moment(date).startOf('day').valueOf();
    this.config.max = this.moment(date).endOf('day').valueOf();
  }


  onChangeTime(date) {
    this.config.dateRef = this.moment(date).toDate();
    this.config.date = this.moment(date).valueOf();
  }

  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.config);
    })
  }

  cancel() {
    this.mdPanelRef.close();
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozDateAndTimePicker', {
    bindings: {
      date: '<',
      isRaised: '@?',
      ticks: '@?',
      minDate: '<?',
      maxDate: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-date-and-time-picker/bringoz-date-and-time-picker.html',
    controller: BringozDateAndTimePickerComponent
  });
